// Data operations texts
export const DATA_TEXTS = {
  getSensorData: 'Get Sensor Data',
  downloadCsv: 'Download CSV',
  loading: 'Loading data...',
  exporting: 'Exporting data...',
  errors: {
    START_DATE_AFTER_END_DATE: 'Start date cannot be after end date',
    LIMIT_INVALID: 'Limit must be greater than 0',
    OFFSET_INVALID: 'Offset cannot be negative',
    DATE_RANGE_TOO_LARGE: 'Date range cannot exceed 365 days',
    SENSORS_REQUIRED_FOR_CSV: 'At least one sensor must be selected for CSV export',
    TOO_MANY_SENSORS_FOR_CSV: 'Cannot export data for more than 50 sensors at once',
    CSV_DATE_RANGE_TOO_LARGE: 'CSV export date range cannot exceed 90 days',
    GET_SENSOR_DATA_FAILED: 'Failed to retrieve sensor data',
    DOWNLOAD_CSV_FAILED: 'Failed to download CSV file'
  }
} as const;